import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const displayCategories = categories.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              探索 <strong className="text-primary-500">aqdlt</strong> 服务分类
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              涵盖六大核心服务领域，为您提供一站式的 aqdlt 解决方案
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {displayCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group p-6 rounded-lg bg-background-100 transition-all duration-300 hover:bg-primary-50 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 mb-4 transition-all duration-300 group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
                <div className="flex items-center gap-1 mt-4 text-sm text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}